module.exports = __webpack_public_path__ + "img/custom-ditto-bg.0ce09c7d.jpg";